import React from "react";
import _ from "lodash";
import { connect } from "formik";
import styled from "styled-components";
import { TextAreaInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const WrapContainer = styled.div`
white-space:pre;
`;

const SideLabelTextAreaInput = ({ label, fieldName, placeholder, formik, isDisabled, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <WrapContainer><ViewOnlyDiv>{val}</ViewOnlyDiv></WrapContainer>}
      {!isDisabled && <TextAreaInput
        fullWidth
        fieldName={fieldName}
        placeholder={placeholder}
      />}
    </LateralField>
  );
};
export default connect(SideLabelTextAreaInput);
